import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { lazy, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import LazyLoader from "src/components/layout/Progress/LazyLoader";
import MyDivider from "src/components/layout/MyDivider";
import { isNumber } from "src/components/js/statics1";

const EditTarjous = lazy(() => import("src/components/tarjous/EditTarjous/EditTarjous"));

export default function AddrTarjous({ tarjousId }) {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [tarjousIdValue, setTarjousIdValue] = useState(tarjousId);
  if (tarjousId !== undefined) tarjousId = Number(tarjousId);
  if (tarjousId !== undefined && isNaN(tarjousId)) tarjousId = 0;

  const handleClose = async () => setIsOpen(false);
  const handleOpen = () => {
    if (tarjousIdValue != tarjousId) navigate("/tarjous/" + tarjousIdValue);
    else setIsOpen(true);
  };

  useEffect(() => {
    if (!isNumber(tarjousId)) {
      navigate("/tarjous");
    } else if (tarjousId) handleOpen();
  }, [tarjousId]);
  //   const navToTarjousId = async (tarjousId) => navigate("/tarjous/" + tarjousId);

  // main render
  return <div>{isOpen ? renderEditTarjous() : renderPage()}</div>;
  function renderPage() {
    return (
      <Box className="center" style={{ height: "70vh" }}>
        <div className="flexCol" style={{ gap: 24 }}>
          <Typography variant="h5" color="primary">
            TARJOUS
          </Typography>
          <MyDivider />
          <Button
            disabled={!isNumber(tarjousIdValue)}
            variant="contained"
            onClick={handleOpen}
            fullWidth
            sx={{ width: "400px", height: "50px" }}>
            AVAA TARJOUS {tarjousIdValue}
          </Button>
          <TextField
            label="TarjousId"
            variant="outlined"
            value={tarjousIdValue}
            onChange={(e) => setTarjousIdValue(e.target.value)}
            type="number"
            fullWidth
          />
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            fullWidth
            sx={{ width: "400px", height: "50px" }}>
            ETUSIVULLE
          </Button>
        </div>
      </Box>
    );
  }

  function renderEditTarjous() {
    return (
      <div className="center">
        <div style={{ maxWidth: "800px", width: "100%" }}>
          <Paper elevation={3} style={{ padding: 20, width: "100%" }}>
            <LazyLoader>
              <EditTarjous
                tarjousId={tarjousId}
                onCancelClick={handleClose}
                onSaveClick={handleClose}
              />
            </LazyLoader>
          </Paper>
        </div>
      </div>
    );
  }
}

AddrTarjous.propTypes = {
  tarjousId: PropTypes.number,
};
